import AcquireOSLogo from '../components/AcquireOSLogo';
import '../styles/signup-choice.css';

const featureItems = [
  {
    label: 'AI Document Reading',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M7 3h7l4 4v14H7z" />
        <path d="M14 3v5h5" />
        <path d="M10 17v-4" />
        <path d="M14 17V9" />
        <path d="M18 17v-6" />
      </svg>
    )
  },
  {
    label: 'Instant Deal Scoring',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M13 2 4 14h7l-1 8 10-13h-7z" />
      </svg>
    )
  },
  {
    label: 'Smart Lender Matching',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M8.5 11.5 11 14a3 3 0 0 0 4.2 0l.8-.8" />
        <path d="M7 15.5 4.5 13a3 3 0 0 1 0-4.2l2.1-2.1a3 3 0 0 1 4.2 0l1.1 1.1" />
        <path d="M13.1 7.8 14.2 6.7a3 3 0 0 1 4.2 0l1.1 1.1a3 3 0 0 1 0 4.2L16 15.5" />
        <path d="M8 12.5 6.5 14" />
      </svg>
    )
  },
  {
    label: 'Auto LOI Generation',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="12" cy="12" r="4" />
        <path d="M12 2v4" />
        <path d="M12 18v4" />
        <path d="M2 12h4" />
        <path d="M18 12h4" />
        <path d="m4.9 4.9 2.8 2.8" />
        <path d="m16.3 16.3 2.8 2.8" />
        <path d="m19.1 4.9-2.8 2.8" />
        <path d="m7.7 16.3-2.8 2.8" />
      </svg>
    )
  },
  {
    label: 'Financial Calculator',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect x="5" y="3" width="14" height="18" rx="2" />
        <path d="M8 7h8" />
        <path d="M8 11h2" />
        <path d="M12 11h2" />
        <path d="M16 11h.01" />
        <path d="M8 15h2" />
        <path d="M12 15h2" />
        <path d="M16 15h.01" />
      </svg>
    )
  },
  {
    label: 'Deal Pipeline Tracker',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 19h16" />
        <path d="M5 17l4-5 4 3 5-8" />
        <circle cx="9" cy="12" r="1" />
        <circle cx="13" cy="15" r="1" />
        <circle cx="18" cy="7" r="1" />
      </svg>
    )
  }
];

export default function SignupChoicePage({ onOrgSetup, onIndividual, onBack }) {
  return (
    <div className="sc-root">

      {/* Left panel — blue brand */}
      <div className="sc-left">
        <div className="sc-left-inner">
          <div className="sc-logo-wrap">
            <AcquireOSLogo size={110} onDark />
            <p className="sc-platform-subtext">Multifamily Deal Intelligence Platform</p>
          </div>

          <div className="sc-features">
            <div className="sc-left-sec-hdr">Integrated Cognitive Modules</div>
            <div className="sc-feature-grid">
              {featureItems.map((feature) => (
                <div className="sc-feature-item" key={feature.label}>
                  <span className="sc-feature-icon">{feature.icon}</span>
                  <span className="sc-feature-label">{feature.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="sc-stats">
            <div className="sc-left-sec-hdr" style={{ marginTop: '8px' }}>Real-time Platform Activity</div>
            <div className="sc-stats-row">
              <div className="sc-stat">
                <span className="sc-stat-num">247</span>
                <span className="sc-stat-desc">Active Deals</span>
              </div>
              <div className="sc-stat">
                <span className="sc-stat-num">$1.2B</span>
                <span className="sc-stat-desc">Total Volume</span>
              </div>
              <div className="sc-stat">
                <span className="sc-stat-num">39.5%</span>
                <span className="sc-stat-desc">Avg. IRR</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Right panel — signup options */}
      <div className="sc-right">
        <div className="sc-card">

          <div className="sc-card-logo">
            <AcquireOSLogo size={64} />
          </div>

          <h1 className="sc-title">How are you signing up?</h1>
          <p className="sc-sub">Choose the profile type that best describes you.</p>

          <div className="sc-options">
            <button className="sc-option sc-option--org" onClick={onOrgSetup}>
              <div className="sc-option-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="7" width="20" height="14" rx="2" />
                  <path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
                  <line x1="12" y1="12" x2="12" y2="16" />
                  <line x1="10" y1="14" x2="14" y2="14" />
                </svg>
              </div>
              <div className="sc-option-text">
                <strong>Organization</strong>
                <span>Investment firm, fund, or company account</span>
              </div>
              <span className="sc-option-arrow">→</span>
            </button>

            <button className="sc-option sc-option--ind" onClick={onIndividual}>
              <div className="sc-option-icon-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                </svg>
              </div>
              <div className="sc-option-text">
                <strong>Individual</strong>
                <span>Solo investor or personal account</span>
              </div>
              <span className="sc-option-arrow">→</span>
            </button>
          </div>

          <button className="sc-back" onClick={onBack}>← Back</button>

        </div>
      </div>

    </div>
  );
}
